<div class="select-search-container">
  <mat-form-field>
    <mat-label>{{label}}</mat-label>
    <mat-select [(ngModel)]="model" (selectionChange)="onValueChange(model)" [disabled]="disabled">
      <mat-option *ngFor="let option of valuesList" [value]="option.value">{{option.viewValue}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
